import { useFeatureFlagsContext } from '@/@feature-flags/context';
import type { FeatureFlagMap } from '@/@feature-flags/types/primitives';

interface UseFeatureFlagsReturn {
    flags: FeatureFlagMap;
    isLoading: boolean;
    error: Error | null;
    refetch: () => void;
    hasFlag: (key: string) => boolean;
}

/**
 * Provides full access to the feature flags context including loading state,
 * error handling, and manual refetch.
 */
export function useFeatureFlags(): UseFeatureFlagsReturn {
    return useFeatureFlagsContext();
}
